import { createSlice } from "@reduxjs/toolkit";
import { getDiscount, getEmployees } from "../../api/employee";

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employee: {},
    loading: false,

    discount: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmployees.pending, (state) => {
        state.loading = true;
      })
      .addCase(getEmployees.fulfilled, (state, { payload }) => {
        state.employee = payload;
        state.loading = false;
      })

      .addCase(getDiscount.fulfilled, (state, { payload }) => {
        state.discount = payload;
      });
  },
});

export default employeeSlice.reducer;
